import React, { useState } from 'react';
import './Navbar.scss';

interface SolutionLink {
  label: string;
  href: string;
}

interface SolutionGroup {
  title: string;
  links: SolutionLink[];
}

const SOLUTION_GROUPS: SolutionGroup[] = [
  {
    title: 'Comercial e vendas',
    links: [
      { label: 'Gestão de Vendas e Clientes', href: '/sistema-de-gestao-de-vendas' },
      { label: 'Comissão de Vendedores', href: '/sistema-de-comissao-de-vendedores' },
      { label: 'Força de Vendas', href: '/sistema-para-forca-de-vendas' },
      { label: 'Orçamentos e Propostas', href: '/sistema-de-orcamentos' },
      { label: 'PDV / Frente de Caixa', href: '/sistema-de-pdv' },
      { label: 'Catálogo de Produtos Online', href: '/catalogo-de-produtos-online' },
      { label: 'Portal do Cliente', href: '/sistema-com-portal-do-cliente' },
      { label: 'Ordem de Serviço', href: '/sistema-de-ordem-de-servico' },
    ],
  },
  {
    title: 'Operacional',
    links: [
      { label: 'Controle de Estoque', href: '/controle-de-estoque' },
      { label: 'Controle de Compras', href: '/sistema-de-controle-de-compras' },
      { label: 'Controle de Frota de Veículos', href: '/controle-de-frota-de-veiculos' },
      { label: 'Manutenção de Equipamentos', href: '/controle-de-manutencao-de-equipamentos' },
    ],
  },
  {
    title: 'Financeiro e fiscal',
    links: [
      { label: 'Controle Financeiro', href: '/controle-financeiro-empresarial' },
      { label: 'Fluxo de Caixa e DRE', href: '/sistema-de-fluxo-de-caixa' },
      { label: 'Cobrança Automática', href: '/sistema-de-cobranca-automatica' },
      { label: 'Emissor de NF-e', href: '/emissor-de-nfe' },
      { label: 'Emissor de NFS-e', href: '/emissor-de-nfse' },
      { label: 'Gestão de Contratos', href: '/sistema-de-gestao-de-contratos' },
    ],
  },
  {
    title: 'Por segmento',
    links: [
      { label: 'Lojas de Varejo', href: '/sistema-para-lojas' },
      { label: 'Distribuidoras', href: '/software-para-distribuidoras' },
      { label: 'Oficina Mecânica', href: '/sistema-para-oficina-mecanica' },
      { label: 'Prestadores de Serviço', href: '/sistema-para-prestadores-de-servico' },
      { label: 'Construtora', href: '/sistema-para-construtora' },
      { label: 'Transportadora', href: '/sistema-para-transportadora' },
      { label: 'Locadora de Equipamentos', href: '/sistema-para-locadora-de-equipamentos' },
      { label: 'Assistência Técnica', href: '/sistema-para-assistencia-tecnica' },
      { label: 'Representante Comercial', href: '/sistema-para-representante-comercial' },
      { label: 'Multiempresa', href: '/sistema-multiempresa' },
    ],
  },
  {
    title: 'Sob medida',
    links: [
      { label: 'ERP Customizado', href: '/erp-customizado' },
    ],
  },
];

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isSolutionsOpen, setIsSolutionsOpen] = useState<boolean>(false);

  const toggleMenu = (): void => {
    setIsMenuOpen(!isMenuOpen);
    setIsSolutionsOpen(false);
  };

  const toggleSolutions = (): void => {
    setIsSolutionsOpen(!isSolutionsOpen);
  };

  const closeAllMenus = (): void => {
    setIsMenuOpen(false);
    setIsSolutionsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <a href="/">
            <img src="/logo/logo-colored.png" alt="77Gestão" className="logo-image" />
          </a>
        </div>

        <button className="navbar-toggle" onClick={toggleMenu}>
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
        </button>

        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className={`navbar-dropdown ${isSolutionsOpen ? 'active' : ''}`}>
            <button
              type="button"
              className="navbar-dropdown-trigger"
              onClick={toggleSolutions}
              aria-expanded={isSolutionsOpen}
            >
              Soluções
              <i className="fa-solid fa-chevron-down" aria-hidden="true" />
            </button>
            <div className="navbar-dropdown-panel">
              {SOLUTION_GROUPS.map((group) => (
                <div className="navbar-dropdown-group" key={group.title}>
                  <span className="navbar-dropdown-group-title">{group.title}</span>
                  <ul>
                    {group.links.map((link) => (
                      <li key={link.href}>
                        <a href={link.href} onClick={closeAllMenus}>{link.label}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </li>
          <li><a href="/#beneficios" onClick={toggleMenu}>Benefícios</a></li>
          <li><a href="/#como-funciona" onClick={toggleMenu}>Como funciona?</a></li>
          <li><a href="/#precos" onClick={toggleMenu}>Preços</a></li>
          <li><a href="/#depoimentos" onClick={toggleMenu}>Depoimentos</a></li>
          <li><a href="/#faq" onClick={toggleMenu}>FAQ</a></li>
          <li><a href="https://blog.77gestao.com.br" target="_blank" rel="noopener noreferrer" onClick={toggleMenu}>Blog</a></li>
        </ul>

        <div className="navbar-cta">
          <a href="https://app.77gestao.com.br/cadastro?source=navbar" className="cta-button" target="_blank" rel="noopener noreferrer">Quero testar</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
